import React from 'react'

function Services() {
    return (
        <section id="services" className="services">
            <div className="container">
                <div className="section-title">
                    <h2>Professional Expertise</h2>
                    <p>Core Competencies & Services</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
                        <div className="icon-box">
                            <div className="icon"><i className="ri-code-box-line"></i></div>
                            <h4>Full Stack Development</h4>
                            <p>Build modern web applications using React, Next.js, PHP (Laravel), and ASP.NET MVC, developing responsive front-end interfaces and robust RESTful APIs for enterprise-scale solutions.</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
                        <div className="icon-box">
                            <div className="icon"><i className="ri-settings-3-line"></i></div>
                            <h4>DevOps & CI/CD</h4>
                            <p>Design and maintain CI/CD pipelines, automate deployment workflows, and implement infrastructure-as-code practices to improve deployment efficiency and release management.</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
                        <div className="icon-box">
                            <div className="icon"><i className="ri-server-line"></i></div>
                            <h4>Infrastructure Management</h4>
                            <p>Manage Linux (RHEL) and Windows Server environments, configure Apache web servers, oversee application hosting, and maintain IT infrastructure for enterprise applications.</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
                        <div className="icon-box">
                            <div className="icon"><i className="ri-database-2-line"></i></div>
                            <h4>Database Optimization</h4>
                            <p>Optimize MySQL, PostgreSQL, and SQL Server databases through query optimization, indexing strategies, stored procedure refinement, and performance monitoring for maximum efficiency.</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
                        <div className="icon-box">
                            <div className="icon"><i className="ri-speed-line"></i></div>
                            <h4>Performance & SEO Optimization</h4>
                            <p>Improve website performance through Core Web Vitals optimization, technical SEO implementation, page speed enhancements, and caching strategies for better user experience.</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4">
                        <div className="icon-box">
                            <div className="icon"><i className="ri-cloud-line"></i></div>
                            <h4>DNS, SSL & Hosting</h4>
                            <p>Configure DNS records, manage SSL certificates, integrate Cloudflare CDN, and maintain secure hosting environments with optimal performance and reliability.</p>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}

export default Services